export default __webpack_public_path__ + "static/globe-322ff5c4bc8b2e2a20e0d5d9fc764af7.png";